import withHeaderItem from '@/utils/hoc/withHeaderItem'
import { useFullscreenStore } from '@/store/fullscreenStore'
import { TbMaximize, TbMaximizeOff } from 'react-icons/tb'
import type { CommonProps } from '@/@types/common'

const _FullscreenToggle = ({ className }: CommonProps) => {
    const { isFullscreen, toggleFullscreen } = useFullscreenStore()

    return (
        <div
            className={className}
            role="button"
            title={isFullscreen ? 'Exit fullscreen' : 'Enter fullscreen'}
            onClick={toggleFullscreen}
        >
            {isFullscreen ? (
                <TbMaximizeOff className="text-2xl" />
            ) : (
                <TbMaximize className="text-2xl" />
            )}
        </div>
    )
}

const FullscreenToggle = withHeaderItem(_FullscreenToggle)

export default FullscreenToggle

